import { BuildTheme } from './Theme-variable'

const ThemeSettings = () => {
  const theme = BuildTheme()
  return theme
}
export default ThemeSettings
